export default __webpack_public_path__ + "static/media/rotated_ReitanWelcomeIMG.7068e086.png";